(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/banner-type-quickplay/assets/javascripts/get-product-data.js') >= 0) return;  svs.modules.push('/components/content/banner-type-quickplay/assets/javascripts/get-product-data.js'); 'use strict';

const quickPlayProductsData = [{
  type: 'tur',
  product: 'keno',
  sum: '30',
  quickPlayProductId: 'keno_30',
  description: '6 rader'
}, {
  type: 'tur',
  product: 'keno',
  quickPlayProductId: 'keno_60',
  sum: '60',
  description: '6 rader<br>med Kung Keno'
}, {
  type: 'tur',
  product: 'keno',
  sum: '120',
  description: '12 rader<br>med Kung Keno',
  quickPlayProductId: 'keno_120'
}, {
  type: 'tur',
  product: 'keno',
  sum: '250',
  quickPlayProductId: 'keno_250',
  description: '25 rader<br>med Kung Keno'
}, {
  type: 'tur',
  product: 'lotto',
  sum: '40',
  quickPlayProductId: 'lotto_40',
  description: '5 rader<br>Lotto 1 & 2 + Joker (10kr)'
}, {
  type: 'tur',
  product: 'lotto',
  sum: '100',
  quickPlayProductId: 'lotto_100',
  description: '15 rader<br>Lotto 1 & 2 + Joker (10kr)'
}, {
  type: 'tur',
  product: 'lotto',
  sum: '200',
  quickPlayProductId: 'lotto_200',
  description: '30 rader<br>Lotto 1 & 2 + Joker (20kr)'
}, {
  type: 'tur',
  product: 'eurojackpot',
  sum: '100',
  quickPlayProductId: 'eurojackpot_100',
  description: '4 rader'
}, {
  type: 'tur',
  product: 'eurojackpot',
  sum: '200',
  quickPlayProductId: 'eurojackpot_200',
  description: '8 rader'
}, {
  type: 'tur',
  product: 'vikinglotto',
  sum: '60',
  quickPlayProductId: 'vikinglotto_60',
  description: '6 rader'
}, {
  type: 'tur',
  product: 'vikinglotto',
  sum: '120',
  quickPlayProductId: 'vikinglotto_120',
  description: '12 rader'
}, {
  type: 'tur',
  product: 'eurojackpot',
  sum: '400',
  quickPlayProductId: 'eurojackpot_400',
  description: '16 rader'
}, {
  type: 'tur',
  product: 'rubbet',
  sum: '89',
  emblemOutline: true,
  quickPlayProductId: 'rubbet_89',
  description: '5 färdiga miljonspel<br>Lotto + Joker x2, Eurojackpot, Keno och Vikinglotto'
}, {
  type: 'tur',
  product: 'rubbet',
  sum: '170',
  emblemOutline: true,
  quickPlayProductId: 'rubbet_170',
  description: '5 färdiga miljonspel<br>Lotto + Joker x2, Eurojackpot, Keno och Vikinglotto'
}, {
  type: 'tur',
  product: 'rubbet',
  sum: '370',
  emblemOutline: true,
  quickPlayProductId: 'rubbet_370',
  description: '5 färdiga miljonspel<br>Lotto + Joker x2, Eurojackpot, Keno och Vikinglotto'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '70',
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_70',
  description: 'Lotto + Joker och Keno'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '140',
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_140',
  description: 'Lotto + Joker och Keno'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '210',
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_210',
  description: 'Lotto + Joker och Keno'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '100',
  emblemOutline: true,
  test: true,
  quickPlayProductId: 'lordagsgodis_tb_triss_100',
  description: 'Lotto + Joker, Keno och Triss'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '170',
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_triss_170',
  description: 'Lotto + Joker, Keno och Triss'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '240',
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_triss_240',
  description: 'Lotto + Joker, Keno och Triss'
}, {
  type: 'sport',
  product: 'em-tipset',
  productName: 'EM Tipset',
  productId: '2',
  sum: '32',
  quickPlayProductId: 'extratipset_32',
  description: '32 rader'
}, {
  type: 'sport',
  product: 'em-tipset',
  productName: 'EM Tipset',
  productId: '2',
  sum: '64',
  quickPlayProductId: 'extratipset_64',
  description: '64 rader'
}, {
  type: 'sport',
  product: 'em-tipset',
  productName: 'EM Tipset',
  productId: '2',
  sum: '128',
  buttonInverted: true,
  quickPlayProductId: 'extratipset_128',
  description: '128 rader'
}, {
  type: 'sport',
  product: 'stryktipset',
  productName: 'Stryktipset',
  productId: '1',
  sum: '32',
  quickPlayProductId: 'stryktipset_32',
  description: '32 rader'
}, {
  type: 'sport',
  product: 'stryktipset',
  productName: 'Stryktipset',
  productId: '1',
  sum: '64',
  quickPlayProductId: 'stryktipset_64',
  description: '64 rader'
}, {
  type: 'sport',
  product: 'stryktipset',
  productName: 'Stryktipset Tips-SM',
  productId: '1',
  sum: '64',
  quickPlayProductId: 'stryktipset_64_competition',
  description: 'Tips-SM, 64 rader',
  isCompetition: true
}, {
  type: 'sport',
  product: 'stryktipset',
  productName: 'Stryktipset',
  productId: '1',
  sum: '128',
  buttonInverted: true,
  quickPlayProductId: 'stryktipset_128',
  description: '128 rader'
}, {
  type: 'sport',
  product: 'europatipset',
  productName: 'Europatipset',
  productId: '2',
  sum: '32',
  quickPlayProductId: 'europatipset_32',
  description: '32 rader'
}, {
  type: 'sport',
  product: 'europatipset',
  productName: 'Europatipset',
  productId: '2',
  sum: '64',
  quickPlayProductId: 'europatipset_64',
  description: '64 rader'
}, {
  type: 'sport',
  product: 'europatipset',
  productName: 'Europatipset',
  productId: '2',
  sum: '128',
  quickPlayProductId: 'europatipset_128',
  description: '128 rader'
}, {
  type: 'sport',
  product: 'challenge',
  productName: 'Challenge',
  productId: '45',
  sum: '60',
  quickPlayProductId: 'challenge_60',
  description: '6 rader'
}, {
  type: 'sport',
  product: 'challenge',
  productName: 'Challenge',
  productId: '45',
  sum: '80',
  quickPlayProductId: 'challenge_80',
  description: '8 rader'
}, {
  type: 'sport',
  product: 'challenge',
  productName: 'Challenge',
  productId: '45',
  sum: '120',
  quickPlayProductId: 'challenge_120',
  description: '12 rader'
}, {
  type: 'sport',
  product: 'bomben',
  productName: 'Bomben',
  productId: '7',
  sum: '40',
  quickPlayProductId: 'bomben_40',
  description: '40 rader'
}, {
  type: 'sport',
  product: 'bomben',
  productName: 'Bomben',
  productId: '7',
  sum: '60',
  quickPlayProductId: 'bomben_60',
  description: '60 rader'
}, {
  type: 'sport',
  product: 'bomben',
  productName: 'Bomben',
  productId: '7',
  sum: '100',
  quickPlayProductId: 'bomben_100',
  description: '100 rader'
}, {
  type: 'sport',
  product: 'maltipset',
  productName: 'Måltipset',
  productId: '8',
  sum: '15',
  quickPlayProductId: 'maltipset_6',
  description: '6 rader'
}, {
  type: 'sport',
  product: 'maltipset',
  productName: 'Måltipset',
  productId: '8',
  sum: '25',
  quickPlayProductId: 'maltipset_10',
  description: '10 rader'
}, {
  type: 'sport',
  product: 'maltipset',
  productName: 'Måltipset',
  productId: '8',
  sum: '35',
  quickPlayProductId: 'maltipset_14',
  description: '14 rader'
}, {
  type: 'sport',
  product: 'powerplay',
  productName: 'Powerplay',
  productId: '28',
  sum: '32',
  quickPlayProductId: 'powerplay_32',
  description: '32 rader'
}, {
  type: 'sport',
  product: 'powerplay',
  productName: 'Powerplay',
  productId: '28',
  sum: '64',
  quickPlayProductId: 'powerplay_64',
  description: '64 rader'
}, {
  type: 'sport',
  product: 'powerplay',
  productName: 'Powerplay',
  productId: '28',
  sum: '108',
  quickPlayProductId: 'powerplay_108',
  description: '108 rader'
}, {
  type: 'sport',
  product: 'topptipset',
  productName: 'Topptipset',
  productId: '25',
  sum: '32',
  quickPlayProductId: 'topptipset_32',
  description: '32 rader'
}, {
  type: 'sport',
  product: 'topptipset',
  productName: 'Topptipset',
  productId: '25',
  sum: '64',
  quickPlayProductId: 'topptipset_64',
  description: '64 rader'
}, {
  type: 'sport',
  product: 'topptipset',
  productName: 'Topptipset',
  productId: '25',
  sum: '108',
  quickPlayProductId: 'topptipset_108',
  description: '108 rader'
}];

function getProductData(banner) {
  return Object.assign({}, banner, quickPlayProductsData.filter(product => product.quickPlayProductId === banner.quickPlayProductId)[0]);
}

if (typeof module === 'object' && typeof module.exports === 'object') {
  module.exports = getProductData;
} else {
  svs.content.bannerTypeQuickplay.getProductData = getProductData;
}
 })(window);